import { IFormRegister } from 'routes/Main/type';
import { Box, Typography } from '@mui/material';

import Form from 'components/Form';
import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';

interface Props extends IFormRegister {
  disabled?: boolean;
}

const Signature = (props: Props) => {
  const { disabled, register } = props;

  const labels = [
    {
      title: 'Chữ ký của bệnh nhân, người giám hộ',
      variable: 'companion_name',
    },
    { title: 'Ngày', variable: 'companion_sig' },
  ];

  const labels2 = [
    { title: 'Chữ ký của bác sĩ', variable: 'dr_name' },
    { title: 'Ngày', variable: 'dr_sig' },
  ];

  return (
    <>
      <RowContainer xs={12} mb={3}>
        {labels.map(({ title, variable }, _) => (
          <>
            {variable === 'companion_sig' ? (
              <RowContent
                key={variable}
                title={title}
                titleRatio={0.5}
                childrenRatio={2}
              >
                <Form.MuiTextField
                  type="date"
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            ) : (
              <RowContent
                key={variable}
                title={title}
                titleRatio={2}
                childrenRatio={2}
              >
                <Form.MuiTextField
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            )}
          </>
        ))}
        <Box
          sx={{
            width: '95.5%',
            margin: '20px auto 10px auto',
          }}
        >
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '15px',
              lineHeight: '24px',
              whiteSpace: 'pre-wrap',
            }}
          >
            Tôi xác nhận rằng tôi đã giải thích bản chất, mục đích, lợi ích, rủi
            ro, biến chứng và các phương pháp thay thế của quy trình đề xuất cho
            bệnh nhân hoặc đại diện pháp lý của bệnh nhân. Tôi
            <br />
            đã trả lời đầy đủ tất cả các câu hỏi, và tôi tin rằng bệnh nhân
            và/hoặc đại diện pháp lý của bệnh nhân hoàn toàn hiểu rõ những gì
            tôi đã giải thích.
          </Typography>
        </Box>

        {labels2.map(({ title, variable }, _) => (
          <>
            {variable === 'dr_sig' ? (
              <RowContent
                key={variable}
                title={title}
                titleRatio={0.5}
                childrenRatio={2}
              >
                <Form.MuiTextField
                  type="date"
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            ) : (
              <RowContent
                key={variable}
                title={title}
                titleRatio={2}
                childrenRatio={2}
              >
                <Form.MuiTextField
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            )}
          </>
        ))}
      </RowContainer>
    </>
  );
};

export default Signature;
